import React from 'react';
import cn from 'classnames';

export default React.forwardRef(
  ({ src, name, onClick, className, isLarge, children }, ref) => {
    const initials =
      name &&
      name
        .split(' ')
        .map((x) => x[0])
        .join('')
        .toUpperCase();

    return (
      <div
        ref={ref}
        className={cn('avatar', className, { lg: isLarge })}
        style={{
          ...(src && { backgroundImage: `url('${src}')` }),
          backgroundColor: '#e3e9eb',
        }}
        onClick={onClick}
        aria-hidden="true"
      >
        {!src && <span className="avatar-initials">{initials}</span>}
        {children}
      </div>
    );
  }
);
